/* Publish by EComposer at 2024-07-25 14:47:43*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ge7tbww8slo"]=  window.__ectimmers["ecom-ge7tbww8slo"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ge7tbww8slo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ge7tbww8slo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1dn4jn3e1wp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1dn4jn3e1wp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hkdhbp8ynl7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hkdhbp8ynl7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i4yzy48hml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i4yzy48hml', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h70uwbm5wh4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h70uwbm5wh4', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ophs8zjq48b"]=  window.__ectimmers["ecom-ophs8zjq48b"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-ophs8zjq48b"]["e0wq7niu5"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click(),Shopify.analytics.publish("ec_custom_events",{button_id:i.id,tracking_id:i.dataset.ecTrackingId}),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ophs8zjq48b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ophs8zjq48b', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-s0l143orqg"]=  window.__ectimmers["ecom-s0l143orqg"] || {};
if(!this.$el)return!1;const e=this.$el,i=this,t=this.settings.animation,n=new CustomEvent("animation",function(){});let s=e.querySelector(".ecom__heading");s.querySelector("a")&&(s=s.querySelector("a")),s.addEventListener("animation",()=>{o()}),s.addEventListener("blur",function(a){a.target.dispatchEvent(n)});function o(){if(t==="typing"){let a=function(){setTimeout(function(){var h;let b=(h=f.settings)==null?void 0:h.animation;if(r.innerText=c[g].slice(0,u),l)if(u>c[g].length){l=!1,b=="typing"&&setTimeout(function(){a()},2e3);return}else u++;else u===0?(l=!0,g=(g+1)%c.length):u--;a()},l?120:60)},r=e.querySelector(".highlight-animation--typing");if(!r)return!1;let c=r.dataset.heading.split("|")||"",u=0,l=!0,g=0;const f=i;a()}if(t==="smooth"){let a=function(){let c=0,u= window.__ectimmers["ecom-s0l143orqg"]["24qhur1vu"] = setInterval(function(){t!="smooth"&&clearInterval(u),c++,r.forEach((l,g)=>{c==r.length&&(c=0),g==c?l.classList.add("is-active"):l.classList.remove("is-active")})},3e3)},r=e.querySelectorAll(".heading-animation--smooth-item");if(!r)return!1;a()}}o()

                    });
                    
                        document.querySelectorAll('.ecom-s0l143orqg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s0l143orqg', settings: {"animation":"smooth"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zhhzja1nyki"]=  window.__ectimmers["ecom-zhhzja1nyki"] || {};
const e=this.$el;if(!e||!this.isLive)return;const i=e.querySelector(".element__featured--wrapper-list");if(i){let t={top:0,left:0,x:0,y:0};const n=function(a){const r=a.clientX-t.x;i.scrollLeft=t.left-r},s=function(){i.removeEventListener("mousemove",n),i.removeEventListener("mouseup",s),i.style.cursor="default",i.style.removeProperty("user-select")},o=function(a){i.style.cursor="grabbing",i.style.userSelect="none",t={left:i.scrollLeft,top:i.scrollTop,x:a.clientX,y:a.clientY},i.addEventListener("mousemove",n),i.addEventListener("mouseup",s)};i.addEventListener("mousedown",o),i.addEventListener("mouseleave",s)}

                    });
                    
                        document.querySelectorAll('.ecom-zhhzja1nyki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zhhzja1nyki', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-cfzd2l2rftq"]=  window.__ectimmers["ecom-cfzd2l2rftq"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-cfzd2l2rftq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cfzd2l2rftq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q8dqcf5pkz7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q8dqcf5pkz7', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3xhwy86jvp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3xhwy86jvp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cpzwau0g3yw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cpzwau0g3yw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s162ckoyrf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s162ckoyrf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o24ur0m7rc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o24ur0m7rc', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7y7gih8onyr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7y7gih8onyr', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2tmng6lnvx7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2tmng6lnvx7', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-55fjchpugd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-55fjchpugd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wiwufa0yu1i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wiwufa0yu1i', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}